import Button, { YellowButton } from "../../../components/UI/Button/button";
import classes from "./jobs.module.css";
import { useNavigate } from "react-router";
import { useCallback, useEffect, useState } from "react";
import { errorHandler } from "../../../utils";
import {
  jobApplicants,
  jobApplicantsById,
  getAllClientJobs,
  getAllClientPostedJobs,
  getCompletedJob,
  clientJobDrafts,
  clientDeleteJob,
  clientStartTrial,
  clientCheckTrial,
  postSubscription,
  subscriptionHistory,
  getCancelledJob,
  clientMatchRandomTalent,
  findClientSubscription,
  getClientJobById,
} from "../../../services/clientCalls";
import ErrorModal from "../../../layout/ErrorModal/ErrorModal";
import confusedStan from "../../../assets/illustrations/approving-stan-blue.png";
import congratsStan from "../../../assets/illustrations/congrats-stan.svg";
import mark from "../../../assets/illustrations/mark.png";
import close from "../../../assets/illustrations/close.svg";
import modalImg from "../../../assets/illustrations/confused-stan-blue.png";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import { NextIcon, PrevIcon, PublishIcon } from "../../../constants/svg";
import {
  MarkJobModal,
  CloseJobModal,
} from "../../../components/CancelMatch/modal/modal";
import { Link, useSearchParams } from "react-router-dom";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";
import SubPopup from "../../../components/NewJob/SubPopup/popup";
import img1 from "../../../assets/illustrations/cancel-match.png";
import JobCard from "../../../components/JobCard/JobCard";
import { DEFAULT_CLIENT_SUBSCRIPTION } from "../../../constants";
import Breadcrumb from "../../../components/UI/Breadcrumb/Breadcrumb";
import JobsHero from "./JobsHero";
import JobsToolbar from "./JobsToolbar";
import {
  IconBriefcaseOff,
  IconChevronLeft,
  IconChevronRight,
  IconPlus,
} from "@tabler/icons-react";
import JobDetailsModal from "./Modal/JobDetails";
import CustomModal from "../../../components/Modal/CustomModal";
import ApplicantsModal from "./Modal/ApplicantsModal";

const TABS = [
  { key: "all", label: "All" },
  { key: "active", label: "Active" },
  { key: "in-review", label: "In Review" },
  { key: "drafts", label: "Drafts", status: "draft" },
  { key: "archived", label: "Archived" },
  { key: "completed", label: "Completed" },
  { key: "cancelled", label: "Closed" },
];

const Jobs = () => {
  let navigate = useNavigate();
  const [param] = useSearchParams();
  const [state, setState] = useState("all");
  const [jobArr, setJobArr] = useState([]);
  const [completedJobsArr, setCompletedJobsArr] = useState([]);
  const [cancelledJobsArr, setCancelledJobArr] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [jobsData, setJobsData] = useState(null);
  const [completedJobsData, setCompletedJobsData] = useState(null);
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [cancelSuccessModal, setCancelSuccessModal] = useState(false);
  const [proceedModal, setProceedModal] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [applicantID, setApplicantID] = useState("");
  const [markJobModal, setMarkJobModal] = useState(false);
  const [markType, setMarkType] = useState("");
  const [load, setLoad] = useState(false);

  const [totalItems, setTotalItems] = useState(null);
  const [totalItemsAll, setTotalItemsAll] = useState(null);
  const [totalItemsCompleted, setTotalItemsCompleted] = useState(null);
  const [allJobsArr, setAllJobsArr] = useState(null);
  const [allJobsData, setAllJobsData] = useState(null);
  const [cancelledJobsData, setCancelledJobsData] = useState(null);
  const [inReviewJobs, setInReviewJobs] = useState([]);
  const [inReviewJobsData, setInReviewJobsData] = useState(null);
  const [talentId, setTalentId] = useState(param.get("talentId") || "");
  const [matchRandomSuccess, setMatchRandomSuccess] = useState(false);

  const [jobDraftArr, setJobDraftArr] = useState([]);
  const [jobsDraftData, setJobsDraftData] = useState(null);
  const [totalItemsDraft, setTotalItemsDraft] = useState(null);

  const [subscriptionID, setSubscriptionID] = useState("");

  const [subscribeIsLoading, setSubscribeIsLoading] = useState(false);
  const [subPopModal, setSubPopModal] = useState(false);
  const [subscriptionActive, setIsSubscriptionActive] = useState(false);
  const [selectedPlanName, setSelectedPlanName] = useState(
    DEFAULT_CLIENT_SUBSCRIPTION,
  );

  const [jobDetailsModalOpen, setJobDetailsModalOpen] = useState(false);
  const [applicantsModalOpen, setApplicantsModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [matchResponse, setMatchResponse] = useState(null);

  // Action Handlers
  const onViewApplicants = () => {
    setJobDetailsModalOpen(false);
    setApplicantsModalOpen(true);
  };

  const onViewDetails = () => {
    setApplicantsModalOpen(false);
    setJobDetailsModalOpen(true);
  };

  const onRequestClose = (job) => {
    const jobToClose = job || selectedJob;
    if (jobToClose) {
      setSelectedJob(jobToClose);
      setApplicantID(jobToClose?._id);
    }
    setJobDetailsModalOpen(false);
    setCancelModal(true);
  };

  const onEdit = (job) => {
    const jobToEdit = job || selectedJob;
    const rawType = String(jobToEdit?.jobType || "job").toLowerCase();
    const pathType = rawType === "gig" ? "gig" : "job";
    navigate(
      `/add-new-job/${pathType}?edit=true&id=${jobToEdit?._id}`,
    );
    setJobDetailsModalOpen(false);
  };

  // Open modal
  const openJobDetails = (jobData) => {
    setSelectedJob(jobData);
    setApplicantsModalOpen(false);
    setJobDetailsModalOpen(true);
    fetchSingleJob(jobData);
  };

  const openApplicants = (jobData) => {
    setSelectedJob(jobData);
    setJobDetailsModalOpen(false);
    setApplicantsModalOpen(true);
    setApplicants([]);
    fetchSingleJob(jobData);
  };

  const fetchAllJobs = async (page) => {
    setLoad(true);
    try {
      const res = await getAllClientJobs(page);
      if (page !== res?.data?.data?.counts) {
        setAllJobsData(res?.data?.data);
        setTotalItemsAll(res?.data?.data?.totalItems);
      }
      if (res?.data.data.records) {
        setAllJobsArr(res.data.data.records);
      }
      setLoad(false);
    } catch (error) {
      setLoad(false);
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };
  const fetchInReviewJobs = async (page) => {
    try {
      const res = await getAllClientJobs(page, "in-review");
      if (page !== res?.data?.data?.counts) {
        setInReviewJobsData(res?.data?.data);
        setTotalItems(res?.data?.data?.totalItems);
      }
      if (res?.data.data.records) {
        setInReviewJobs(res.data.data.records);
      }
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };
  const fetchCompletedJobs = async (page) => {
    try {
      const res = await getCompletedJob(page);
      if (page !== res?.data?.data?.counts) {
        setCompletedJobsData(res?.data?.data);
        setTotalItemsCompleted(res?.data?.data?.totalItems);
      }
      if (res?.data.data.records) {
        setCompletedJobsArr(res.data.data.records);
      }
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const fetchJobApplicantsById = async (page) => {
    try {
      const res = await jobApplicantsById(page);
      if (page !== res?.data?.data?.counts) {
        setJobsData(res?.data?.data);
        setTotalItems(res?.data?.data?.totalItems);
      }
      if (res?.data.data.records) {
        setJobArr(res.data.data.records);
      }
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const fetchJobApplicants = async (page) => {
    try {
      setLoad(true);
      const res = await getAllClientJobs(page, "active");
      if (page !== res?.data?.data?.counts) {
        setJobsData(res?.data?.data);
        setTotalItems(res?.data?.data?.totalItems);
      }
      if (res?.data.data.records) {
        setJobArr(res.data.data.records);
      }
      setLoad(false);
    } catch (error) {
      setLoad(false);
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const fetchJobDrafts = async (page) => {
    try {
      const res = await clientJobDrafts(page);
      if (page !== res?.data?.data?.counts) {
        setJobsDraftData(res?.data?.data);
        setTotalItems(res?.data?.data?.totalItems);
      }
      if (res?.data.data.records) {
        setJobDraftArr(res.data.data.records);
      }
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const deleteJob = async (id) => {
    setLoad(true);
    try {
      const res = await clientDeleteJob(id);
      if (res.data) {
        setLoad(false);
        fetchJobDrafts();
        fetchJobApplicants();
      }
    } catch (error) {
      setLoad(false);
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const publishJob = async () => {
    setLoad(true);
    try {
      const res = await clientDeleteJob();
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const handleStartTrial = async () => {
    setLoad(true);
    try {
      const res = await clientStartTrial();
      setLoad(false);
    } catch (error) {
      setLoad(false);
    }
  };

  const handleCheckTrial = async () => {
    setLoad(true);
    try {
      const res = await clientCheckTrial();
      const data = res.data?.data;

      const canStartTrial =
        !data?.trialStatus?.isActive &&
        data?.trialStatus?.matchUsed === 0 &&
        new Date(data?.trialStatus?.endDate) > new Date();

      if (canStartTrial) {
        handleStartTrial();
      }
    } catch (error) {
    } finally {
      setLoad(false);
    }
  };

  const handleFindClientSubscription = async () => {
    try {
      const payload = {
        name: selectedPlanName,
      };
      if (selectedPlanName) {
        const res = await findClientSubscription(payload);
        const subscriptionId = res?.data?.data?.subscription?._id;
        if (subscriptionId) {
          return subscriptionId;
        }
      } else {
        errorHandler("Please select a plan", "Error");
        return null;
      }
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const handleSubscription = useCallback(async () => {
    setSubscribeIsLoading(true);
    try {
      const subscriptionId = await handleFindClientSubscription();
      if (subscriptionId) {
        setSubscriptionID(subscriptionId);
        const res = await postSubscription(subscriptionId);
        if (res?.data?.data?.data?.data?.authorization_url) {
          window.location.href = res?.data?.data?.data?.data?.authorization_url;
        }
      }
    } catch (error) {
      setSubscribeIsLoading(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setSubscribeIsLoading(false);
    }
  }, [selectedPlanName]);

  const fetchSubscription = async () => {
    try {
      const res = await subscriptionHistory();

      if (res.data.data.records.length > 0) {
        // setSubscriptionID(res.data.data.records[0]._id)
      }
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const fetchCancelled = async (page) => {
    try {
      setLoad(true);
      const res = await getCancelledJob(page);
      if (page !== res?.data?.data?.counts) {
        setCancelledJobsData(res?.data?.data);
      }
      if (res?.data.data.records) {
        setCancelledJobArr(res.data.data.records);
      }
      setLoad(false);
    } catch (error) {
      setLoad(false);
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const offerModal = localStorage.getItem("offerSubscriptionModal");
  useEffect(() => {
    if (subscriptionID && offerModal) {
      setSubPopModal(true);
    }
  }, [subscriptionID]);

  useEffect(() => {
    handleCheckTrial();
    fetchSubscription();
  }, []);

  useEffect(() => {
    fetchCompletedJobs();
    fetchJobDrafts();
    fetchCancelled();
  }, []);

  useEffect(() => {
    if (param.get("tab") === "drafts") {
      setState("drafts");
    }
  }, []);

  useEffect(() => {
    Promise.allSettled([
      fetchAllJobs(1),
      fetchJobApplicants(1),
      fetchInReviewJobs(1),
    ]);
  }, []);

  useEffect(() => {
    if (completeModal || cancelSuccessModal) {
      fetchInReviewJobs();
      fetchJobApplicants();
      setTimeout(() => {
        setCompleteModal(false);
        setCancelSuccessModal(false);
      }, 3000);
    }
  }, [completeModal, cancelSuccessModal]);

  const handleMatchRandomTalent = async (jobId) => {
    try {
      setLoad(true);
      const res = await clientMatchRandomTalent(jobId, talentId);
      const data = res?.data?.data;
      if (res?.data?.success && data) {
        setMatchRandomSuccess(true);
        setMatchResponse(data);
        setTimeout(() => {
          navigate("/talent?tab=matches&view=list", { state: data });
        }, 2000);
      }
    } catch (error) {
      error.response.data
        ? errorHandler(error.response.data.errors, "Error", () => navigate(-1))
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setLoad(false);
    }
  };

  const counts = {
    all: allJobsData?.totalItems ?? 0,
    active: jobsData?.totalItems ?? 0,
    "in-review": inReviewJobs?.length ?? 0,
    drafts: jobsDraftData?.totalItems ?? 0,
    archived: cancelledJobsData?.totalItems ?? 0,
    completed: completedJobsData?.totalItems ?? 0,
    cancelled: cancelledJobsData?.totalItems ?? 0,
  };

  const [loading, setLoading] = useState(false);
  const [applicants, setApplicants] = useState([]);

  const fetchSingleJob = async (jobData) => {
    if (!jobData?._id) return;
    setLoading(true);
    try {
      const res = await getClientJobById(jobData._id);
      if (res?.data?.data?.job) {
        setSelectedJob(res.data.data.job);
        setApplicants(res?.data?.data?.formattedApplicants || []);
      }
    } catch (error) {
      error?.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.container}>
      {load && <FullScreenLoader />}

      <div className="flex items-center justify-between gap-4 mb-4">
        <Breadcrumb
          crumbs={[
            { label: "Dashboard", href: "/client-activity-summary" },
            { label: "My Jobs" },
          ]}
          title="My Jobs"
        />

        <Button
          as={Link}
          to="/add-new-job/job"
          variant="primary"
          className="py-2 min-h-10"
          leftIcon={<IconPlus size={15} />}
        >
          Add a new Job/Gig
        </Button>
      </div>

      {/* Hero */}
      <JobsHero
        total={allJobsData?.totalItems ?? 0}
        active={jobsData?.totalItems ?? 0}
        applicants={0}
        inReview={inReviewJobs?.length ?? 0}
      />
      {/* Tabs */}
      <JobsToolbar
        tabs={TABS}
        activeTab={state}
        onChange={setState}
        counts={counts}
      />

      <div className={classes.box}>
        {/* for all jobs here */}
        {state === "all" && (
          <>
            {allJobsArr?.map((item, index) => (
              <JobCard
                key={index}
                setApplicantID={setApplicantID}
                setCancelModal={setCancelModal}
                setMarkJobModal={setMarkJobModal}
                setMarkType={setMarkType}
                deleteJob={deleteJob}
                publishJob={publishJob}
                tab={"all"}
                talentId={talentId}
                handleMatchRandomTalent={handleMatchRandomTalent}
                job={item}
                setSelectedJob={setSelectedJob}
                setJobDetailsModalOpen={setJobDetailsModalOpen}
                onOpenApplicants={openApplicants}
                onOpenDetails={openJobDetails}
              />
            ))}

            {allJobsArr?.length === 0 && !load && (
              <EmptyState
                title="You have not created a Job or Gig"
                message="Start by creating a new job"
              />
            )}

            {allJobsData?.totalItems > 1 && allJobsArr?.length > 0 && (
              <Pagination
                pageSize={10}
                onChange={(e) => {
                  setPage(e);
                  fetchAllJobs(e);
                }}
                current={allJobsData?.currentPage}
                total={allJobsData?.totalItems}
                nextIcon={<IconChevronRight size={16} />}
                prevIcon={<IconChevronLeft size={16} />}
                showTitle={false}
              />
            )}
          </>
        )}

        {/* for active jobs here */}
        {state === "active" && (
          <>
            {jobArr?.length > 0 &&
              jobArr?.map((item, index) => (
                <JobCard
                  key={index}
                  setApplicantID={setApplicantID}
                  setCancelModal={setCancelModal}
                  setMarkJobModal={setMarkJobModal}
                  setMarkType={setMarkType}
                  deleteJob={deleteJob}
                  publishJob={publishJob}
                  tab={"active"}
                  job={item}
                  setJobDetailsModalOpen={setJobDetailsModalOpen}
                  setSelectedJob={setSelectedJob}
                  onOpenDetails={openJobDetails}
                  onOpenApplicants={openApplicants}
                />
              ))}

            {jobArr?.length < 1 && (
              <EmptyState
                title="You have no active jobs"
                message="Start by creating a new job"
              />
            )}
            <div>
              <MarkJobModal
                setShowModal={setMarkJobModal}
                setCompleteModal={setCompleteModal}
                setCancelModal={setCancelSuccessModal}
                markType="complete"
                applicantID={applicantID}
                onSuccess={() => {
                  fetchJobApplicants();
                  fetchInReviewJobs();
                  fetchAllJobs();
                }}
                job={selectedJob}
                open={markJobModal}
                onClose={() => setMarkJobModal(false)}
              />
            </div>
            {jobsData?.totalItems > 1 && jobArr?.length > 0 && (
              <Pagination
                pageSize={10}
                onChange={(e) => {
                  setPage(e);
                  fetchJobApplicants(e);
                }}
                current={jobsData?.currentPage}
                total={jobsData?.totalItems}
                nextIcon={<IconChevronRight size={16} />}
                prevIcon={<IconChevronLeft size={16} />}
                showTitle={false}
              />
            )}
          </>
        )}

        {state === "in-review" && (
          <>
            {inReviewJobs?.map((item, index) => (
              <JobCard
                key={index}
                setApplicantID={setApplicantID}
                setCancelModal={setCancelModal}
                setMarkJobModal={setMarkJobModal}
                setMarkType={setMarkType}
                deleteJob={deleteJob}
                publishJob={publishJob}
                tab={"active"}
                job={item}
                setJobDetailsModalOpen={setJobDetailsModalOpen}
                setSelectedJob={setSelectedJob}
                onOpenDetails={openJobDetails}
                onOpenApplicants={openApplicants}
              />
            ))}

            {inReviewJobs?.length < 1 && (
              <EmptyState
                title="You have no jobs in review"
                message="Start by creating a new draft job"
              />
            )}

            {inReviewJobsData?.totalItems > 1 && inReviewJobs?.length > 0 && (
              <Pagination
                pageSize={10}
                onChange={(e) => {
                  setPage(e);
                  fetchInReviewJobs(e);
                }}
                current={inReviewJobsData?.currentPage}
                total={inReviewJobsData?.totalItems}
                nextIcon={<IconChevronRight size={16} />}
                prevIcon={<IconChevronLeft size={16} />}
                showTitle={false}
              />
            )}
          </>
        )}

        {/* for draft jobs here */}
        {state === "drafts" && (
          <>
            {jobDraftArr?.length > 0 &&
              jobDraftArr?.map((item, index) => (
                <JobCard
                  key={index}
                  setApplicantID={setApplicantID}
                  setCancelModal={setCancelModal}
                  setMarkJobModal={setMarkJobModal}
                  setMarkType={setMarkType}
                  tab={"drafts"}
                  deleteJob={deleteJob}
                  publishJob={publishJob}
                  job={item}
                  setJobDetailsModalOpen={setJobDetailsModalOpen}
                  setSelectedJob={setSelectedJob}
                  onOpenDetails={openJobDetails}
                  onOpenApplicants={openApplicants}
                />
              ))}

            {jobDraftArr?.length < 1 && (
              <EmptyState
                title="You have no draft jobs"
                message="Start by creating a new draft job"
              />
            )}
            {/* <ToastErrorModal setShowModal={true}/> */}
            {totalItemsDraft > 1 && jobDraftArr?.length > 0 && (
              <Pagination
                pageSize={10}
                onChange={(e) => {
                  setPage(e);
                  fetchAllJobs(e);
                }}
                current={jobsDraftData?.currentPage}
                total={totalItems}
                nextIcon={<IconChevronRight size={16} />}
                prevIcon={<IconChevronLeft size={16} />}
                showTitle={false}
              />
            )}
          </>
        )}

        {/* for completed jobs here */}
        {state === "completed" && (
          <>
            {completedJobsArr?.map((item, index) => (
              <JobCard
                key={index}
                setApplicantID={setApplicantID}
                setCancelModal={setCancelModal}
                setMarkJobModal={setMarkJobModal}
                setMarkType={setMarkType}
                deleteJob={deleteJob}
                publishJob={publishJob}
                tab={"completed"}
                job={item}
                setJobDetailsModalOpen={setJobDetailsModalOpen}
                setSelectedJob={setSelectedJob}
                onOpenDetails={openJobDetails}
                onOpenApplicants={openApplicants}
              />
            ))}

            {completedJobsArr?.length < 1 && (
              <EmptyState
                title="You have no completed jobs"
                message="Start by creating a new draft job"
              />
            )}

            {completedJobsData?.totalItems > 1 &&
              completedJobsArr?.length > 0 && (
                <Pagination
                  pageSize={10}
                  onChange={(e) => {
                    setPage(e);
                    fetchCompletedJobs(e);
                  }}
                  current={completedJobsData?.currentPage}
                  total={completedJobsData?.totalItems}
                  nextIcon={<IconChevronRight size={16} />}
                  prevIcon={<IconChevronLeft size={16} />}
                  showTitle={false}
                />
              )}
          </>
        )}

        {/* for cancelled jobs here */}
        {(state === "cancelled" || state === "archived") && (
          <>
            {cancelledJobsArr?.map((item, index) => (
              <JobCard
                key={index}
                setApplicantID={setApplicantID}
                setCancelModal={setCancelModal}
                setMarkJobModal={setMarkJobModal}
                setMarkType={setMarkType}
                deleteJob={deleteJob}
                publishJob={publishJob}
                tab={"cancelled"}
                job={item}
                setJobDetailsModalOpen={setJobDetailsModalOpen}
                setSelectedJob={setSelectedJob}
                onOpenDetails={openJobDetails}
                onOpenApplicants={openApplicants}
              />
            ))}

            {cancelledJobsArr?.length < 1 && (
              <EmptyState
                title="You have no cancelled jobs"
                message="Start by creating a new draft job"
              />
            )}

            {cancelledJobsData?.totalItems > 1 &&
              cancelledJobsArr?.length > 0 && (
                <Pagination
                  pageSize={10}
                  onChange={(e) => {
                    setPage(e);
                    fetchCancelled(e);
                  }}
                  current={cancelledJobsData?.currentPage}
                  total={cancelledJobsData?.totalItems}
                  nextIcon={<IconChevronRight size={16} />}
                  prevIcon={<IconChevronLeft size={16} />}
                  showTitle={false}
                />
              )}
          </>
        )}
      </div>

      <JobDetailsModal
        job={selectedJob}
        open={jobDetailsModalOpen}
        onClose={() => setJobDetailsModalOpen(false)}
        onViewApplicants={onViewApplicants}
        onRequestClose={onRequestClose}
        onEdit={onEdit}
        loading={loading}
        applicants={applicants}
      />

      <ApplicantsModal
        job={selectedJob}
        open={applicantsModalOpen}
        onClose={() => setApplicantsModalOpen(false)}
        onViewDetails={onViewDetails}
        loading={loading}
        applicants={applicants}
      />

      <CloseJobModal
        type={"cancel"}
        applicantID={applicantID}
        setShowModal={setCancelModal}
        setCompleteModal={setCompleteModal}
        setCancelModal={setCancelSuccessModal}
        markType={markType}
        job={selectedJob}
        open={cancelModal}
        onClose={() => setCancelModal(false)}
      />

      <ErrorModal
        isModalOpen={cancelSuccessModal}
        setModalOpen={setCancelSuccessModal}
      >
        <div className={`${classes.modal} ${classes.congratsModal}`}>
          <div className="flex flex-col items-center md:flex-row gap-6 md:gap-10 my-8">
            <img
              className={`${classes.modalImage} md:!w-40 !w-24`}
              src={congratsStan}
              alt=""
            />
            <div className="relative z-10">
              <img
                className={`${classes.closeImage} absolute`}
                src={close}
                alt=""
              />
              <div className="mx-auto md:pr-10">
                <h2 className="md:text-3xl text-xl font-semibold mb-6 text-white">
                  Great!
                </h2>
                <h3 className="text-sm md:text-xl mb-8 text-white">
                  You just sent a request to close this job. <br />
                  please await our response after review
                </h3>
                <YellowButton
                  className="!w-24 h-9"
                  onClick={() => setCancelSuccessModal(false)}
                >
                  Continue
                </YellowButton>
              </div>
            </div>
          </div>
        </div>
      </ErrorModal>

      <ErrorModal isModalOpen={completeModal} setModalOpen={setCompleteModal}>
        <div className={`${classes.modal} ${classes.congratsModal}`}>
          <div className="flex flex-col items-center md:flex-row gap-6 md:gap-10 my-8">
            <img
              className={`${classes.modalImage} md:!w-40 !w-24`}
              src={congratsStan}
              alt=""
            />
            <div className="relative z-10">
              <img
                className={`${classes.markImage} absolute`}
                src={mark}
                alt=""
              />
              <div className="mx-auto md:pr-10">
                <h2 className="md:text-3xl text-xl font-semibold mb-6 text-white">
                  Congratulations!
                </h2>
                <h3 className="text-sm md:text-xl mb-8 text-white">
                  Your job was successfully completed. <br />
                  please await our response after review
                </h3>
                <YellowButton
                  className="!w-24 h-9"
                  onClick={() => setCompleteModal(false)}
                >
                  Continue
                </YellowButton>
              </div>
            </div>
          </div>
        </div>
      </ErrorModal>
      <ErrorModal isModalOpen={proceedModal} setModalOpen={setProceedModal}>
        <div className={classes.modal}>
          <img className={classes.modalImage} src={modalImg} alt="" />
          <p>Sure you want to proceed?</p>
          <div className={classes.modalButton}>
            <YellowButton onClick={() => setProceedModal(false)}>
              No
            </YellowButton>
            <YellowButton
              onClick={() =>
                isCancel ? setCancelModal(true) : setCompleteModal(true)
              }
            >
              Yes
            </YellowButton>
          </div>
        </div>
      </ErrorModal>

      {matchRandomSuccess && (
        <CustomModal
          state="success"
          title="Your job was successfully mapped to a Talent"
          description=""
          primaryLabel="Continue"
          onClose={() => {
            setMatchRandomSuccess(false);
            navigate("/talent?tab=matches&view=list", { state: matchResponse });
          }}
          onPrimaryAction={() => {
            setMatchRandomSuccess(false);
            navigate("/talent?tab=matches&view=list", { state: matchResponse });
          }}
        />
      )}

      {subPopModal && (
        <SubPopup
          showModal={() => {
            setSubPopModal(false);
            localStorage.removeItem("offerSubscriptionModal");
          }}
          onClick={() => {
            handleSubscription();
            localStorage.removeItem("offerSubscriptionModal");
          }}
          subscribeIsLoading={subscribeIsLoading}
        />
      )}
    </div>
  );
};

export default Jobs;

export const EmptyState = ({ title, message, bare = false, to, btnText }) => {
  return (
    <div
      className={classes.emptyState}
      style={bare ? { border: "none", padding: "48px 24px" } : undefined}
    >
      <div className={classes.emptyIcon}>
        <IconBriefcaseOff size={30} />
      </div>
      <h3>{title}</h3>
      <p>{message}</p>
      <Button
        className="my-3"
        as={Link}
        to={"/add-new-job/job"}
        variant={"secondary"}
      >
        Create Job
      </Button>
    </div>
  );
};
